module.exports = __webpack_public_path__ + "img/tax_icon.38ac212a.svg";